import dayjs, { Dayjs } from "dayjs";

export const formatDate = (date?: Date | Dayjs | null) => {
  if (!date) {
    return "";
  }
  return dayjs(date).format("DD/MM/YYYY") !== "Invalid Date"
    ? dayjs(date).format("DD/MM/YYYY")
    : "-";
};

export const formatDateTime = (date?: Date | null) => {
  if (!date) {
    return "";
  }
  return dayjs(date).format("DD/MM/YYYY HH:mm");
};

export const formatDateTimeNoAMPM = (date?: Date | null) => {
  if (!date) {
    return "";
  }
  return dayjs(date).format("DD/MM/YYYY HH:mm");
};

export const formatDateTimeWithSeconds = (date?: Date | null) => {
  if (!date) {
    return "";
  }
  return dayjs(date).format("DD/MM/YYYY HH:mm:ss");
};

export const formatDateExport = (date?: Date | null) => {
  return dayjs(date).format("DD-MM-YYYY");
};
